import React, { Fragment } from "react";
import FormControl from "@material-ui/core/FormControl";
import { InputLabel, MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { Skeleton } from "@material-ui/lab";
import { isBlank } from "../../util/ext";

const CustomDropdownSelect = props => {
  const { dropdownItems, onChange, value } = props;

  return (
    <Fragment>
      {isBlank(dropdownItems) ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <InputLabel htmlFor="custom_dropdown_items">Custom Dropdown Item</InputLabel>
          <Select
            value={value || ""}
            onChange={onChange}
            inputProps={{
              name: "custom-dropdown",
              id: "custom-dropdown",
            }}
          >
            {dropdownItems.map(di => {
              return (
                <MenuItem value={di.customDropdownId} key={di.customDropdownId}>
                  {di.customDropdownName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </Fragment>
  );
};

export default CustomDropdownSelect;
